import { LinkButton, Text, Tooltip } from '@etg/wings';
import Media from 'react-media';
import { css, mediaQueries } from '@eti/styles';
import type { AncillaryCarrierPriceBreakdown } from '@eti/schema-types';
import { price as priceUtil } from '@eti/utils';
import { CartRow, Price } from '../../CartComponents';

const tooltipColumnGapStyles = css`
  margin-top: 4px;
`;

const pricePerProductTooltipStyles = css`
  ${tooltipColumnGapStyles};
  display: grid;
  grid-template-columns: 3fr 1fr;
`;

export interface CartProductCarrierPriceBreakdownTypes {
  ancillaryCarrierPriceBreakdowns: AncillaryCarrierPriceBreakdown[];
  pricePerAgeTypeLabel: string;
  productDisplayName: string;
  productName: string;
  totalProductPrice: number;
  travelerIndex: number;
}

const CartProductCarrierPriceBreakdown = ({
  ancillaryCarrierPriceBreakdowns = [],
  pricePerAgeTypeLabel,
  productDisplayName,
  productName,
  totalProductPrice,
  travelerIndex,
}: CartProductCarrierPriceBreakdownTypes) => (
  <CartRow
    data-testid={`cart-product-${productName}`}
    key={`cart-product-${productName}-${travelerIndex}`}
  >
    {ancillaryCarrierPriceBreakdowns.length > 1 ? (
      <Tooltip
        content={
          <>
            <Text>{pricePerAgeTypeLabel}</Text>
            {ancillaryCarrierPriceBreakdowns.map(({ carrier, providerPrice }, index: number) => (
              <CartRow
                className={pricePerProductTooltipStyles}
                key={`cart-product-${productName}-carrier-price-breakdown-${carrier?.name?.toLowerCase()}-${index}`}
              >
                <Media query={`${mediaQueries.small.only}`}>
                  {(isMobile) =>
                    isMobile ? (
                      <Text>{carrier?.name ?? ''}</Text>
                    ) : (
                      <Text>{`${productDisplayName} ${carrier?.name ?? ''}`}</Text>
                    )
                  }
                </Media>
                <Price
                  data-testid={`cart-product-provider-cost-carrier-${carrier?.name?.toLowerCase()}-${index}`}
                >
                  {priceUtil.formatPrice(providerPrice?.value ?? 0)}
                </Price>
              </CartRow>
            ))}
          </>
        }
        data-testid={`cart-product-${productName}-carrier-price-tooltip-traveler-${travelerIndex}`}
        title={productDisplayName}
        trigger="click"
      >
        <LinkButton data-testid={`cart-product-${productName}-link-button`}>
          {productDisplayName}
        </LinkButton>
      </Tooltip>
    ) : (
      <Text>{`${productDisplayName} ${
        ancillaryCarrierPriceBreakdowns[0]?.carrier?.name ?? ''
      }`}</Text>
    )}
    <Price data-testid={`cart-product-${productName}-price`}>
      {priceUtil.formatPrice(totalProductPrice)}
    </Price>
  </CartRow>
);

export default CartProductCarrierPriceBreakdown;
